<template>
  <div id="pageRoot">
    <div id="bg">
      <img src="/pages/img/sordocas/svgCas33bg.svg" />
      <p class="textBaseCourier" id="text01">LAS PARTES DE UN CASTILLO</p>
      <p class="textBaseCourier textSimple" id="text02">
        En la parte central del castillo estaban las habitaciones y los
        almacenes de víveres. Ese lugar se llamaba torre del homenaje. También
        solían tener un patio interno o patio de armas y caballerizas.
      </p>

      <p class="textBaseCourier" id="text03">LOS CASTILLOS EN LA ACTUALIDAD</p>
      <p class="textBaseCourier textSimple" id="text04">
        En esta época, la mayoría de los castillos están deshabilitados y
        reciben a los turistas que desean visitarlos
      </p>
      <p class="textBaseCourier textSimple" id="text05">
        *Texto adaptado para este cuaderno.
      </p>
    </div>

    <img
      id="zorrito"
      class="pageElement hover-animation-a"
      src="/pages/img/sordocas/svgCas33Zorrito.svg"
    />
  </div>
</template>
<style scoped>
.textSimple {
  font-size: 22px;
  line-height: 33px;
  color: #000000;
}

#text01 {
  position: absolute;
  width: 284px;
  left: 40px;
  top: 67px;
  font-weight: bold;
  font-size: 35px;
  line-height: 40px;
  color: #231f20;
}
#text02 {
  position: absolute;
  width: 322px;
  height: 285px;
  left: 40px;
  top: 178px;
  color: #231f20;
}
#text03 {
  position: absolute;
  left: 40px;
  top: 505px;
  font-weight: bold;
  font-size: 35px;
  line-height: 45px;
  color: #231f20;
}
#text04 {
  position: absolute;
  width: 540px;
  height: 730px;
  left: 40px;
  top: 569px;
  color: #231f20;
}
#text05 {
  position: absolute;
  left: 40px;
  top: 690px;
  color: #231f20;
}
#zorrito {
  position: absolute;
  z-index: 4;
  left: 678px;
  top: 482px;
}

#bg {
  position: absolute;
  left: 31px;
  top: 41px;
  z-index: 3;
  opacity: 0;
  animation-name: enciclopedia-appear;
  animation-duration: 1s;
  animation-delay: 0.3s;
  animation-timing-function: cubic-bezier(0, 0, 0.3, 1.3);
  animation-fill-mode: forwards;
}
@keyframes enciclopedia-appear {
  from {
    opacity: 0;
    top: 500px;
  }
  to {
    opacity: 1;
    top: 41px;
  }
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 130.mp4",
        "cas/Video 131a.mp4",
        "cas/Video 131b.mp4",
        "cas/Video 132.mp4",
        "cas/Video 133.mp4",
      ],
    };
  },
};
</script>